<template>
    <div class="  con_content">
        <div class="container">
            <div class="container_top h_48">
                音乐管理
               
            </div>     
            <div >
                
                <!-- table组件 -->
                <div class="my_table">
                    
                    <div class="my_search">
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10">所属类目 : &nbsp;</div> 
                                <div class="lft pointer" :class="[title_num == -1 ?'colorP':'']"  @click="title_num = -1;guid = 'better'"  > 推荐 </div>
                                <div class="lft pointer" v-for="(item,num) in titles" :class="[title_num == num?'colorP':'']"  @click="title_num = num;guid = item.guid" :key="num"> &nbsp; <span class="cBlack">/</span> &nbsp;{{item.name}} </div>
                                
                                                
                            </div> 
                             
                            <Button class="rgt mR20 top14" @click="route='/layout/circle/music/add';out_btnFun(null,0)"  type="info">添加音乐</Button> 
                            <Button class="rgt mR20 top14" @click="lookFun"  type="info">查看类目</Button>   
                        </Row>        
                    </div>
                  
                </div>
                <div class="my_table">
                    
                    <div class="my_search" >
                        
                        <Row class="search_row">  
                            <div  class="search_name">
                         
                                <div class="lft mR10 fw900 fon fs18">音乐列表 </div> 
                                       
                            </div> 
                            <Col span="4" class="listIpt rgt mR20">
                                <Input  ref='isFocuseA'    :maxlength='20' @keyup.enter.native="nameFun" v-model="name"  class='ipt   top13 '  placeholder="请输入音乐名"  >
                                    <Button size="small" @click='nameFun'   slot="append" icon="md-search"></Button>
                                </Input>
                            </Col>
                            
                        </Row>        
                    </div>
                  
                    <Table     border :columns="columns1" :data="data1" ref='table' >
                 
                        <!-- 播放试听 -->
                        <template slot-scope="{ row, index }" slot="url" >
                 
                            <span  >
                                
                                <!-- <audio :src="row.url"  controls> </audio> -->
                                <!--vue-aplayer插件-->
                                 <aplayer   
                                    
                                    :music="{
                                        title: row.name,
                                        author: '♬',
                                        url: row.url,
                                        pic: row.thumb,
                                        
                                        preload: 'metadata'
                                    }"
                                  ></aplayer>
                            </span>
  
                        </template>                      
                        <template slot-scope="{ row, index }" slot="btn" >
                 
                            <span  >
                                <Poptip trigger="hover"   content="编辑">
                                    <Button class="padlr5" size="small"  @click='route="/layout/circle/music/editor";out_btnFun(row,1)'  type="success"      icon="md-open"></Button>
                                </Poptip>
                                <Poptip trigger="hover"  content="删除">
                                    <Button class="padlr5"  size="small" @click='route="/layout/circle/music/del";out_btnFun(row,2)'  type="error"      icon="md-close"></Button>
                                </Poptip>
                            </span>

                        </template>                      
                          
                    </Table>
                    <Footer>
                       <Page  :current.sync="page" :total="total" :page-size='size'    @on-change='change_page' @on-page-size-change='change_size' show-total  show-sizer      />
                    </Footer>
                    
                </div>
            </div>
        </div>

        <!-- 添加音乐,编辑音乐,删除音乐 -->
        <Modal
            v-model="out_btn"
            :title="out_title"
            
            class-name="vertical-center-modal"
            width="520"
        >
            <div slot="footer">
                <Button type='text' size='large' @click='out_btnFail'>取消</Button>
                <Button type='primary' size='large' @click='out_btnSucc'>{{out_succ}}</Button>
            </div>
            
            <p  v-if="out_btn_num == 2">确定删除音乐吗?</p>
            <ul class="layout_ul" v-if="out_btn_num != 2">
               
                <!-- 标题 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 标题 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model1"   type='text' class="ipt"  placeholder="请输入标题"    />
                    </div>                                            
                </li>
                <!-- 单选 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 分类描述 :</div> 
                    <div class="list_con padt2">
                        <RadioGroup v-model="out_model2">
                            <Radio v-for="(item,num) in data"  :label="item.guid" :key="num">
                                
                                <span>{{item.name}}</span>
                            </Radio>
                            
                        </RadioGroup>
                    </div>                                            
                </li>
                
                <!-- 孝心值 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 孝心值 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model6"   type='number' class="ipt"  placeholder="请输入孝心值"    />
                    </div>                                            
                </li>
                <!-- 排序 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 排序 :</div> 
                    <div class="list_con">
                        <Input   v-model="out_model3"   type='number' class="ipt"  placeholder="请输入排序"    />
                    </div>                                            
                </li>
                <!-- 上传附件 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 上传音频 :</div> 
                    <div class="list_con relative" >
                        <div class="upmusic_zz" v-if="!music_setTime" @click="zzFun"></div>
                        <Upload :format="['wma','mp3','ogg']" 
                                :headers="{'Authorization':'Bearer ' + token}"
                                :data="{guid: my_guid,type:'9'}" 
                                :on-success="up_succ"
                                action="https://api.jiapuji.vip/gateway/attached/service/attached/upload" :max-size="102400"
                                :before-upload="handleUpload"
                                ref="uploadButton"
                                
                        >
                            <Button @click="musicFun" type="info" icon="md-cloud-upload" >上传音频</Button>
                        </Upload>
                        
                        
                    </div>                                            
                </li>
                <!-- 上传附件 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 上传图片 :</div> 
                    <div class="list_con">
                        <cropper @childFun="childFun2"      :data="cropper_data"  ></cropper>

                    </div>                                            
                </li>
                <!-- 是否推荐 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 推荐状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model4" :true-value="Number(1)" :false-value="Number(0)" @on-change="change_out_isBetter" />
                    </div>                                                
                </li>
                <!-- 是否隐藏 -->
                <li>
                    <div class='list_title'> <span v-if="out_btn_num == 0" class="cRed">*</span> 显示状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="out_model5" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_out_display" />
                    </div>                                                
                </li>
            </ul>
        </Modal>           
        <!-- 查看类目  -->
        <Modal
            v-model="lm"
            title="音乐类目"
            class-name="vertical-center-modal"
            width="1000"
            >
            <div slot="footer">     
                <Button type='primary' size='large' @click='lookSucc'>关闭</Button>
            </div>
            <div class="my_table bottom20"  >
                    
                <div class="my_search" style="margin-bottom:1px;">
                    
                    <Row class="search_row">  
                        <div  class="search_name">           <!--  0 添加; 1 编辑; 2 删除  -->
                        <Button class="mR5"    type="info"    @click='route="/layout/circle/music/m_add";m_btnFun(null,0);' > <Icon type="md-add" />添加</Button>                              
                        </div>
                        
                    </Row>
                    
                </div>
                <Table     border :columns="columns" :data="data" ref='table' >
                    <template slot-scope="{ row, index }" slot="btn" >
                 
                        <span  >
                            <Poptip trigger="hover"   content="编辑">
                                <Button class="padlr5" size="small"  @click='route="/layout/circle/music/m_editor";m_btnFun(row,1)'  type="success"      icon="md-open"></Button>
                            </Poptip>
                            <Poptip trigger="hover"  content="删除">
                                <Button class="padlr5"  size="small" @click='route="/layout/circle/music/m_del";m_btnFun(row,2)'  type="error"      icon="md-close"></Button>
                            </Poptip>
                        </span>

                    </template>                        
                </Table>
            
            </div>
        </Modal> 

        <!-- 类目弹窗的按钮弹窗 -->
        <Modal
            v-model="m_btn"
            :title="m_title"
            
            class-name="vertical-center-modal"
            width="520"
        >
            <div slot="footer">
                <Button type='text' size='large' @click='m_btnFail'>取消</Button>
                <Button type='primary' size='large' @click='m_btnSucc'>{{m_succ}}</Button>
            </div>
            
            <p  v-if="m_btn_num == 2">确定删除类目吗?</p>
            <ul class="layout_ul" v-if="m_btn_num != 2">
               
                <!-- 分类名称 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类名称 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model1"   type='text' class="ipt"  placeholder="请输入分类名称"    />
                    </div>                                            
                </li>
                <!-- 分类描述 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类描述 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model2"   type='text' class="ipt"  placeholder="请输入分类描述"    />
                    </div>                                            
                </li>
                <!-- 分类排序 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类排序 :</div> 
                    <div class="list_con">
                        <Input   v-model="m_model3"   type='number' class="ipt"  placeholder="请输入分类排序"    />
                    </div>                                            
                </li>
                <!-- 分类状态 -->
                <li>
                    <div class='list_title'> <span class="cRed">*</span> 分类状态 :</div>         
                    <div class="list_con">
                        <i-switch class='mSwitch' v-model="m_model4" :true-value="Number(0)" :false-value="Number(1)" @on-change="change_btn" />
                    </div>                                                
                </li>
            </ul>
        </Modal>           
    </div>
    
</template>
<script>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    
    import cropper from '../../child_vue/vue_cropper.vue';
    import aplayer from 'vue-aplayer';
    export default {
        name:'recommend',
        data () {
            return {
              
                token: null,
                route: null,
                guid: 'better', 
                my_guid:null,
                titles: [],
                title_num: -1,
                //内容
                columns1:[],   
                data1:[],
                total: null,
                page:1,
                size: 20,
                //搜索
                search_page:1,
                search_size: 20,
                // 类目 
                columns:[],   
                data:[],
              
                // 主体编辑
                out_url: null,  //场景路径
                
                out_model1:null,  //场景名称
                out_model2:null,  //场景guid
                out_model3:0,  //场景排序
                out_model4:0,  //是否推荐
                out_model5:0,  //是否隐藏
                out_model6:0,     //收取孝心值
                

                // 类目编辑
                m_model1:null,  //分类名称
                m_model2:null,  //分类描述
                m_model3:null,  //分类排序
                m_model4:null,  //隐藏分类

                name: null,

                lo: false,
                out_btn: null,  
                out_guid: null,
                out_btn_num: null,
                out_title: null,
                out_succ: null,

                lm: false,     //是否弹出类目
                m_btn: false , //类目弹窗的按钮弹窗
                m_guid: null,
                m_btn_num: 0,
                m_title: "添加类目",
                m_succ: "添加",

                // 上传音乐
                up_data: null,
                file_name: null,
                file_path: null,

                music_setTime: true,  //音乐未上传好不能点击添加修改
                

                // 上传图片
                            
                cropper_data:{
                    btn_name: '上传图片',
                    outputType: 'jpeg',  //生成图片格式
                    type:'9',
                    vCropper:'5',
                    enlarge:"1", 
                    autoCropWidth:"200",
                    autoCropHeight:"200"
                },  

                child_val: null,  //child 反馈
            }
        },
     
        watch:{
           title_num(val){
               let that = this;
               that.load1();
           }
          
        },
        components: {
          aplayer,cropper
        },
        computed: {
            
       
        },
        
        
        methods: {
            
            load(){
              let that = this;
              that.$myAjax.get('admin/service/admin/fame/background/type/image?type=1').then( res => {
                  that.titles = res.data.data;
                  
                  that.columns = [
                       {title:'排序',key:'sort',align:'center',width: 80},
                       {title:'名称',key:'name',align:'center',minWidth: 100,ellipsis: true},
                       {title:'分类描述',key:'content',align:'center',minWidth:150},
                       {title:'状态',key:'display',align:'center',width:'110',
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.display,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {
                                             
                                              that.$myAjax.put(
                
                                                  'admin/service/admin/fame/background/type?route=/layout/circle/music/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 1,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                  that.load();
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                      },
                      {title:'添加时间',key:'createTime',align:'center',minWidth:110,maxWidth:190},
                      {title:'操作',slot:'btn',align:'center',width:160,fixed: 'right'}
                  ];
                  that.data = res.data.data;
                  
                  that.out_model2 = that.data[0].guid;
                  
              })
          },
          load1(){
            
              let that = this;
              let data = {
                  guid: that.guid,
                  page: that.page,
                  size: that.size,
                  type: "1"

              };
              
              
              that.$myAjax.get('admin/service/admin/fame/background/all'+that.$ajaxNull.get(data)).then( res => {
                  that.columns1 = [
                        {title:'排序',key:'sort',align:'center',width: 80},
                        {title:'名称',key:'name',align:'center',minWidth: 100,maxWidth: 250},
                        {title:'播放试听',slot:'url',align:'center',minWidth: 300},
                        {title:'所属条目',key:'backgroundTypeName',align:'center',minWidth: 90,maxWidth:120},
                        {title:'孝心值',key:'money',align:'center',width: 90},
                        {title:'状态',key:'display',align:'center',width:'110',
                            render: (h, params) => {
                           
                              return h('i-switch', {
                                      
                                      props: {
                                          size: "large",
                                          value: params.row.display ,
                                          'true-value': 0,
                                          'false-value': 1
                                      },
                                      on: {
                                          'on-change': (value) => {
                                             
                                              that.$myAjax.put(
                
                                                  'admin/service/admin/background?route=/layout/circle/music/editor',
                                                  {
                                                      "guid": params.row.guid,
                                                      "type": 1,
                                                      "display": value
                                                  },
                                                  
                                              ).then(res => {
                                                  that.load1();
                                          
                                              }).catch(err=>{
                                                  console.log(err)
                                              })


                                          }
                                      }
                                  },
                                  [h('span', {
                                          slot: "open",
                                          domProps: {
                                              innerHTML: '开启'
                                          }
                                      }),
                                      h('span', {
                                          slot: "close",
                                          domProps: {
                                              innerHTML: '关闭'
                                          }
                                      }),
                                  ]
                              )
                            }

                        },
                        {title:'创建时间',key:'createTime',align:'center',minWidth: 110,maxWidth:220},
                        {title:"操作",slot:"btn",align:"center",width:130,fixed: 'right'},
                  ]; 
                  
                  that.data1 = res.data.data.list;
                  that.page = res.data.data.pageNum;
                  that.size = res.data.data.pageSize;
                  that.total = res.data.data.total;
                  //console.log(that.total)
                  //
              })
          },
          
          change_page(){
              this.load1();
          },
          change_size(size){
              this.size = size;
              this.load1();
          },
          
            musicFun(){  //点击上传音频
                let that = this;
         
            },

            // 添加音乐
            //音乐 中按钮 ,out_btn_num 0 添加，1 编辑 ， 2 删除
            out_btnFun(row,num){
                let that = this;
                
                that.music_setTime = true;

                that.out_btn = true;
                that.out_btn_num = num;
                
                if(that.out_btn_num == 0){
                    that.out_title = "添加音乐";
                    that.out_succ = "添加";
                }else if(that.out_btn_num == 1){
                    that.out_guid = row.guid;
                    that.out_title = "编辑音乐";
                    that.out_succ = "修改";
                    
                }else if(that.out_btn_num == 2){
                    that.out_guid = row.guid;
                    that.out_title = "提示";
                    that.out_succ = "删除";
                }
                if(num == 0){
                    that.out_model1 = null;
                    // that.out_model2 = null;
                    that.out_model3 = null;   //排序
                    that.out_model4 = 0;
                    that.out_model5 = 0;
                    that.out_model6 = null;    //收取孝心值
                    that.child_val = null;
                    that.file_name = null;
                }else if(num == 1){
                    that.out_model1 = row.name;
                    that.out_model2 = row.backgroundTypeGuid;
                    that.out_model3 = row.sort;
                    that.out_model4 = row.isBetter;
                    that.out_model5 = row.display;
                    that.out_model6 = row.money;
                    that.child_val = null;
                    that.file_name = null;
                }
            },
            out_btnFail(){
                this.out_btn = false;
            },
            out_btnSucc(){
                let that = this;
                let thumb;

                if(!that.music_setTime){
                    
                    this.$alert.info('音乐上传中'); 
                    return;
                }

                
                let sort = that.out_model3?JSON.parse(that.out_model3):null;
                let money = that.out_model6?JSON.parse(that.out_model6):null;
                let data = {
                    name: that.out_model1,
                    backgroundTypeGuid: that.out_model2,
                    sort: sort,
                    isBetter: that.out_model4,
                    display: that.out_model5,
                    money: money,
                    url: that.file_name,
                    type: "1",
                    thumb: null
                    
                }

                let bn = that.out_btn_num;
                
                if( bn != 2){
                    if(!that.child_val){  //child_val==false 的时候 不上传 图片
                        data.guid = null;
                        data.thumb = null; 
                        if(bn == 0){                     
                            that.$myAjax.post('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }else if(bn == 1){
                            data.guid = that.out_guid;
                            that.$myAjax.put('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                if(res.data.code == 1){
                                    that.out_btnFail();
                                    that.load();
                                    that.load1();
                                }
                            })
                        }              
                    }else{
                        that.$upload(                   //上传图片
                            that.child_val
                        ).then(res => { 
                            data.guid = null;
                            data.thumb = res.data.data.name; 
                            if(bn == 0){                     
                                that.$myAjax.post('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }else if(bn == 1){
                                data.guid = that.out_guid;
                                that.$myAjax.put('admin/service/admin/background?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                                    if(res.data.code == 1){
                                        that.out_btnFail();
                                        that.load();
                                        that.load1();
                                    }
                                })
                            }             
                            
                            
                        }).catch(res => {

                        });
                    }  
                }else if(bn == 2){
                    data.guid = that.out_guid;
                    that.$myAjax.delete('admin/service/admin/background?route=' + that.route+'&guid='+that.out_guid).then( res => {
                        if(res.data.code == 1){
                            that.out_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }


                
               
            },
            // 搜索名称
            nameFun(){
                let that = this;
                let data = {
                  name: that.name,
                  page: that.search_page,
                  size: that.search_size,
                  type: "1"

                };
                if(that.name){
                    that.$myAjax.get('admin/service/admin/fame/background/search'+that.$ajaxNull.get(data)).then( res => {
                        that.data1 = res.data.data.list;
                        that.page = res.data.data.pageNum;
                        that.size = res.data.data.pageSize;
                        that.total = res.data.data.total;
                    })
                }else{
                    that.load1();
                }
                
                
            },
            
           change_out_isBetter(bool){
               this.out_model4 = bool;
          
            },
           change_out_display(bool){
               this.out_model5 = bool;
            
            },
            //   类目
            change_btn(bool){
               this.m_model4 = bool;
              
            },
            //   查看类目
           lookFun(){
               this.lm = true;
           },
            lookSucc(){
               this.lm = false;
            },
            //类目 中按钮 ,m_btn_num 0 添加，1 编辑 ， 2 删除
            m_btnFun(row,num){
                let that = this;
                
                that.m_btn = true;
                that.m_btn_num = num;
                
                if(that.m_btn_num == 0){
                    that.m_title = "添加类目";
                    that.m_succ = "添加";
                }else if(that.m_btn_num == 1){
                    that.m_guid = row.guid;
                    that.m_title = "编辑类目";
                    that.m_succ = "修改";
                    
                }else if(that.m_btn_num == 2){
                    that.m_guid = row.guid;
                    that.m_title = "提示";
                    that.m_succ = "删除";
                }
                if(num == 0){
                    that.m_model1 = null;
                    that.m_model2 = null;
                    that.m_model3 = null;
                    that.m_model4 = 0;
                }else if(num == 1){
                    that.m_model1 = row.name;
                    that.m_model2 = row.content;
                    that.m_model3 = row.sort;
                    that.m_model4 = row.display;
                }
            },
            m_btnFail(){
                this.m_btn = false;
            },
            m_btnSucc(){
                let that = this;
                let data = {
                    name: that.m_model1,
                    content: that.m_model2,
                    sort: that.m_model3,
                    display: that.m_model4,
                    type: "1"
                }
                if(that.m_btn_num == 0){
                    that.$myAjax.post('admin/service/admin/fame/background/type?route=' + that.route,that.$ajaxNull.post(data)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }else if(that.m_btn_num == 1){
                    
                    let data1 = data;
                    data1.guid = that.m_guid;
                    that.$myAjax.put('admin/service/admin/fame/background/type?route=' + that.route,that.$ajaxNull.post(data1)).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }else if(that.m_btn_num == 2){
                    data.guid = that.m_guid;
                    that.$myAjax.delete('admin/service/admin/fame/background/type?route=' + that.route +'&guid='+ that.m_guid ).then( res => {
                        if(res.data.code == 1){
                            that.m_btnFail();
                            that.load();
                            that.load1();
                        }
                    })
                }
            },
            

            //上传音频
            up_succ(opt){
                let that = this;
                that.file_name = opt.data.name;
                that.file_path = opt.data.path;
                
                that.$refs.uploadButton.clearFiles();
                that.music_setTime = true;
                // setTimeout(function(){
                //     that.$Message.info({
                //       content:'音乐上传成功',
                //       duration:3
                //     }); 
                //     that.music_setTime = true;
                // },500)
                
            },

            handleUpload(file){ //选中音乐后
                let that = this;
                that.music_setTime = false;
                
                that.out_model1 = file.name;
                
            },
            zzFun(){
                let that = this;
                this.$Message.info({
                
                    content:'音乐上传中',
                    duration:3
                }); 
            },
            // 上传图片反馈
            childFun2 (data){
                let that = this;
                that.child_val = data.pic_url;          
                
            }

          
            
         
        },
        mounted: function(){
           let that = this;
           that.my_guid = that.$store.state.guid;
           
           that.token = that.$store.state.token;
           that.load();
           that.load1();

        }
    }
</script>
<style scoped>
    .upmusic_zz{
        position: absolute;
    
        top:0;left: 0;
        /* background:red; */
        width:120px;
        height: 100%;
        z-index: 9999;
    }
</style>